import MainHeader from '../../components/MainHeader'
import PagesDirect from '../../components/PagesDirect'
import FAQs from '../../components/FAQs'
import Quotes from '../../components/Quotes'
import Footer from '../../components/Footer'

import './home.css'

const Home = () => {
  return (
    <>
      <MainHeader/>
      <PagesDirect/>
      {/* <FAQs/> */}
      {/* <Quotes/> */}
      <Footer/>
    </>  
  )
}

export default Home